import { render, staticRenderFns } from "./VuetablePaginationDropdownCustom.vue?vue&type=template&id=f065c512&"
import script from "./VuetablePaginationDropdownCustom.vue?vue&type=script&lang=js&"
export * from "./VuetablePaginationDropdownCustom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports